import React, { useMemo } from 'react';

import { Box, TableContainer } from '@mui/material';
import PropTypes from 'prop-types';

import { SystemTableTestIds } from '../../SystemTable.testIds';

import { DEFAULT_TEST_ID } from './TableWrapper.constants';
import {
  collapsingTableWrapperStyles,
  tableContainerStyles,
  wrapperStyles,
} from './TableWrapper.styles';

const defaultObject = {};

const TableWrapper = ({
  toolbar,
  children: tableContent,
  testid = DEFAULT_TEST_ID,
  containerRef,
  customWrapperSx = defaultObject,
}) => {
  const wrapperCommonStyles = useMemo(
    () => ({ ...wrapperStyles, ...customWrapperSx }),
    [customWrapperSx],
  );

  return (
    <Box data-testid={testid} sx={wrapperCommonStyles}>
      {toolbar}
      <Box sx={collapsingTableWrapperStyles}>
        <TableContainer
          data-testid={SystemTableTestIds.CONTENT_CONTAINER}
          ref={containerRef}
          sx={tableContainerStyles}
        >
          {tableContent}
        </TableContainer>
      </Box>
    </Box>
  );
};

TableWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  containerRef: PropTypes.object.isRequired,
  toolbar: PropTypes.node,
  customWrapperSx: PropTypes.object,
  testid: PropTypes.string,
};

export default TableWrapper;
